export default "__VITE_ASSET__msaqKaQy__"